(function () {
  function loadHotjar() {
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:3581522,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  }
  function hasConsent(purpose){
    try{
      var s = window.Didomi && Didomi.getUserStatus ? Didomi.getUserStatus() : null;
      return !!(s && s.purposes && (s.purposes.consent[purpose] || s.purposes.legitimate_interest[purpose]));
    }catch(e){ return false; }
  }
  if (window.didomiOnReady) {
    didomiOnReady(function(){ if (hasConsent('measure_audience')) loadHotjar(); });
  } else {
    loadHotjar();
  }
})();